import { Reveal, SectionHeading } from "@/components/Reveal";
import { GraffitiTag } from "@/components/GraffitiTag";
import { Tilt } from "@/components/Tilt";
import { useContent } from "@/context/ContentContext";

export const Equipment = () => {
  const { content } = useContent();
  const equipment = (content.equipment || []).filter((e) => e.active !== false);

  return (
    <section id="equipment" data-testid="equipment-section" className="relative overflow-hidden py-20 lg:py-32 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
      <GraffitiTag watermark rotate={-7} color="text-champagne" className="absolute -left-8 bottom-8 text-[24vw] lg:text-[12rem] leading-none pointer-events-none select-none hidden md:block">
        Rolling
      </GraffitiTag>
      <SectionHeading
        overline="Who We Serve"
        title="Built for Carriers Who Are Ready to Move Forward."
        testId="equipment-heading"
        tag="Move Forward."
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {equipment.map((e, i) => (
          <Reveal key={e.key || i} delay={0.06 * i}>
            <Tilt max={5}>
              <article
                data-testid={`equipment-card-${e.key || i}`}
                className="group relative overflow-hidden border border-gold/15 hover:border-gold/60 transition-colors duration-500"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={e.image}
                    alt={`${e.title} truck equipment`}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <h3 className="font-display text-2xl font-bold uppercase tracking-wide gold-text">{e.title}</h3>
                  <p className="text-sm text-zinc-300 leading-relaxed mt-2 opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
                    {e.description}
                  </p>
                </div>
                <div className="absolute top-0 left-0 w-10 h-10 border-t-2 border-l-2 border-gold/70" />
                <div className="absolute bottom-0 right-0 w-10 h-10 border-b-2 border-r-2 border-gold/70" />
              </article>
            </Tilt>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-10 text-center text-xs uppercase tracking-[0.2em] text-zinc-500" data-testid="equipment-disclaimer">
          Equipment support is confirmed during your carrier consultation.
        </p>
      </Reveal>
    </section>
  );
};
